//@flow
import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import defaultTheme from './FormField.scss';
import { Text, Flex, Box } from '@locus-taxy/neo-ui';
import { ErrorIcon } from 'common/components/core/icon';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import { HelpTooltip } from 'common/components/core/help';

const FormField = props => {
    const {
        theme,
        children,
        label,
        error,
        helpText,
        column,
        required,
        fullWidth
    } = props;
    return (
        <Flex
            flexDirection={column ? Flex.Direction.Column : null}
            alignItems={Flex.AlignItems.Baseline}
            className={theme.formField}
        >
            <Text
                marginRight="auto"
                textTransform="uppercase"
                fontSize="11px"
                fontWeight="medium"
                className={theme.label}
            >
                {label}
                {required ? (
                    <span className={theme.required}>{'*'}</span>
                ) : null}
                {helpText ? <HelpTooltip tooltipText={helpText} /> : null}
                {error ? (
                    <ErrorIcon
                        theme={theme}
                        visible
                        errorText={error}
                        triggerPopoverOn={PopoverTriggerEnum.Hover}
                    />
                ) : null}
            </Text>
            <Box
                marginTop={column ? 2 : null}
                className={classnames(
                    theme.content,
                    fullWidth ? theme.fullWidth : null
                )}
            >
                {children}
            </Box>
        </Flex>
    );
};

const ThemedFormField = themr('FormField', defaultTheme)(FormField);
export { ThemedFormField as FormField };
export default ThemedFormField;
